import React, { Component } from 'react'
import { render } from 'react-dom'

import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Legend } from 'recharts'

import '../../App.css'

import { InlineMath, BlockMath } from 'react-katex';

import {
  Container,
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

import * as ss from 'simple-statistics'

const binomial_n_init = 5.0
const binomial_p_init = 0.2

class Binomial extends Component {

  constructor(props) {
    super(props);

    this.state = {
      binomial_n: binomial_n_init,
      binomial_p: binomial_p_init,
      vBinomial: ss.binomialDistribution(5, 0.2),
    };

  }

  onBinomialNChangeHandler = (event) => {
    if (event.target.value != "") {
      this.setState({ 
        binomial_n: event.target.value,
        vBinomial: ss.binomialDistribution(event.target.value, this.state.binomial_p),
      });
    } else {
      this.setState({ 
        lambda: binomial_n_init,
        vBinomial:  ss.binomialDistribution(binomial_n_init, binomial_p_init),
      });
    }
  }

  onBinomialPChangeHandler = (event) => {
    if (event.target.value != "") {
      this.setState({ 
        binomial_p: event.target.value,
        vBinomial: ss.binomialDistribution(this.state.binomial_n, event.target.value),
      });
    } else {
      this.setState({ 
        lambda: binomial_p_init,
        vBinomial:  ss.binomialDistribution(binomial_n_init, binomial_p_init),
      });
    }
  }


  render() {

    var binomial_data = [];
    if(this.state.binomial_n != "" &&  this.binomial_p != "") {
      if(this.state.vBinomial.length != 0) {
        for(var i = 0; i < this.state.vBinomial.length; i++){
          binomial_data.push({name: i, pdf: this.state.vBinomial[i], cdf: this.state.vBinomial.slice(0, i + 1).reduce((total, data) => {return total + data})})
        }
      }
    }

    return (
      <div className="base">

        <Header as='h1'>
        二項分布
        </Header>

        <div style={{ textAlign: 'center' }}>
          <div>
            <h3>input <InlineMath>{`\\displaystyle n `}</InlineMath></h3>
          </div>
          <div>
            <input onChange={this.onBinomialNChangeHandler} />
          </div>
          <div>
            <h3>input <InlineMath>{`\\displaystyle p `}</InlineMath></h3>
          </div>
          <div>
            <input onChange={this.onBinomialPChangeHandler} />
          </div>
          <p>{this.state.keyword}</p>
        </div>


      <Container text style={{ marginTop: '5em',"font-size":"110%" }}>
        <ResponsiveContainer width="80%" height="80%" minWidth={400} minHeight={300}>
          <LineChart width={400} height={200} data={binomial_data}>
            <XAxis dataKey="name" />
            <YAxis />
            <Legend />
            <Line dataKey="pdf" stroke="#8884d8" />
            <Line dataKey="cdf" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </Container>

      </div>
    )   
  }
}

export default Binomial;
